
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, HorizontalPadding} from '../../../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import ThanksMascot from '../../../../assets/icon/mascot/thanks_mascot.svg'
import BlogButton from '../../../../assets/icon/sitter/mobile/blog.svg';
import InstaButton from '../../../../assets/icon/sitter/mobile/insta.svg';

const WriteDoneBrowserComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();
    const navigate = useNavigate();    
    const [searchParams, setSearchParams] = useSearchParams();
    const name = searchParams.get("name")

    const onDone = () => {
        navigate("/")
    }

    const onBlog = () => {
        window.open("https://blog.naver.com/spacepetofficial", "_blank")
    }

    const onInsta = () => {
        window.open("https://www.instagram.com/space.pet_official/", "_blank")
    }

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.screen_Web}>
                        <div style={styles.mainCon_Web}>
                            <img src={ThanksMascot} style={styles.mascot_Web} alt="마스코트" />
                            <span style={styles.title_Web}>지원해주셔서 감사해요</span>
                            <span style={styles.content_Web}>{name} 지원자님, 지원이 완료됐어요.<br />
                                서류 결과는 지원서 접수 후 영업일 기준 3일 이내에 카카오 알림톡으로 보내드려요.</span>
                            <div style={styles.button_Web} onClick={() => onDone()}>
                                확인
                            </div>
                        </div>

                        <div style={{ height: "18vh" }} />
                        <span style={styles.subTitle_Web}>우주펫 최신 소식 보러가기</span>

                        <div style={styles.rowCon_Web}>
                            <img src={BlogButton} style={styles.iconButton_Web} alt="버튼" onClick={() => onBlog()} />
                            <div style={{ width: "2vw" }} />
                            <img src={InstaButton} style={styles.iconButton_Web} alt="버튼" onClick={() => onInsta()} />
                        </div>
                    </div>

                </>
            ) : (
                <>
                    <div style={styles.screen_Mobile}>
                        <div style={styles.mainCon_Mobile}>
                            <img src={ThanksMascot} style={styles.mascot_Mobile} alt="마스코트" />
                            <span style={styles.title_Mobile}>지원해주셔서 감사해요</span>
                            <span style={styles.content_Mobile}>{name} 지원자님, 지원이 완료됐어요.<br />서류 결과는 지원서 접수 후 영업일 기준 3일 이내에 카카오 알림톡으로 보내드려요.</span>
                            <div style={styles.button_Mobile} onClick={() => onDone()}>
                            확인
                            </div>
                        </div>

                    <div style={{ height: "9.3750vh" }} />

                    <span style={styles.subTitle_Mobile}>우주펫 최신 소식 보러가기</span>

                        <div style={styles.rowCon_Mobile}>
                            <img src={BlogButton} style={styles.iconButton_Mobile} alt="버튼" onClick={() => onBlog()} />
                        <div style={{ width: "12.5000vw" }} />
                            <img src={InstaButton} style={styles.iconButton_Mobile} alt="버튼" onClick={() => onInsta()} />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: { width: "50%", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingTop: responsivePaddingVertical(105, 204), paddingBottom: responsivePaddingVertical(73, 129), boxSizing: "border-box", paddingLeft: responsivePaddingHorizontal(24, 57), paddingRight: responsivePaddingHorizontal(24, 57) },
    mainCon_Web: { width: "100%", backgroundColor: "#F9F5FF", borderRadius: "10px", paddingTop: responsivePaddingVertical(26, 27), paddingBottom: responsivePaddingVertical(26, 27), paddingLeft: HorizontalPadding(22, 32), paddingRight: HorizontalPadding(22, 32), display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box" },
    mascot_Web: { width: 110, height: 74 },
    title_Web: { color: "black", fontSize: responsiveFont(20, 22), fontWeight: 700, lineHeight: "100%", letterSpacing: "-2%", marginTop: 10, marginBottom: 20, marginLeft: 0, marginRight: 0 },
    content_Web: { color: "#62686D", fontSize: responsiveFont(15, 20), fontWeight: 400, lineHeight: "150%", letterSpacing: "-3%", marginTop: 0, marginBottom: 20, marginLeft: 0, marginRight: 0 },
    button_Web: { width: "100%", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box", paddingTop: responsivePaddingVertical(15, 17), paddingBottom: responsivePaddingVertical(15, 17), paddingLeft: HorizontalPadding(15, 15), paddingRight: HorizontalPadding(15, 15), color: "white", fontSize: responsiveFont(16, 18), fontWeight: 700, lineHeight: "130%", letterSpacing: "-1%", backgroundColor: "#9F6BFF" },
    subTitle_Web: { display: "flex", alignSelf: "center", color: "#1B1D1F", fontSize: responsiveFont(14, 20), fontWeight: 700, lineHeight: "100%", letterSpacing: "-2%", textAlign: "center", marginTop: 0, marginBottom: 30, marginLeft: 0, marginRight: 0, fontFamily: "Pretendard" },
    rowCon_Web: { width: "100%", display: "flex", alignItems: "center", justifyContent: "center" },
    iconButton_Web: { width: 84, height: 84 },

    screen_Mobile: { width: "100%", minWidth:"320px", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingTop: responsivePaddingVertical(105, 204), paddingBottom: responsivePaddingVertical(73, 129), boxSizing: "border-box", paddingLeft: responsivePaddingHorizontal(24, 57), paddingRight: responsivePaddingHorizontal(24, 57) },
    mainCon_Mobile: { width: "100%", backgroundColor: "#F9F5FF", borderRadius: "10px", paddingTop: responsivePaddingVertical(26, 27), paddingBottom: responsivePaddingVertical(26, 27), paddingLeft: HorizontalPadding(22, 32), paddingRight: HorizontalPadding(22, 32), display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box" },
    mascot_Mobile: { width: 110, height: 74 },
    title_Mobile: { color: "black", fontSize: responsiveFont(20, 22), fontWeight: 700, lineHeight: "100%", letterSpacing: "-2%", marginTop: "1.5625vh", marginBottom: "3.1250vh", marginLeft: 0, marginRight: 0 },
    content_Mobile: { color: "#62686D", fontSize: responsiveFont(15, 20), fontWeight: 400, lineHeight: "150%", letterSpacing: "-3%", marginTop: 0, marginBottom: "3.1250vh", marginLeft: 0, marginRight: 0 },
    button_Mobile: { width: "100%", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box", paddingTop: responsivePaddingVertical(15, 17), paddingBottom: responsivePaddingVertical(15, 17), paddingLeft: HorizontalPadding(15, 15), paddingRight: HorizontalPadding(15, 15), color: "white", fontSize: responsiveFont(16, 18), fontWeight: 700, lineHeight: "130%", letterSpacing: "-1%", backgroundColor: "#9F6BFF" },
    subTitle_Mobile: { display: "flex", alignSelf: "center", color: "black", fontSize: responsiveFont(14, 20), fontWeight: 600, lineHeight: "120%", letterSpacing: "-2%", textAlign: "center", marginTop: 0, marginBottom: "3.1250vh", marginLeft: 0, marginRight: 0 },
    rowCon_Mobile: { width: "100%", display: "flex", alignItems: "center", justifyContent: "center" },
    iconButton_Mobile: { width: 84, height: 84 }
});

export default WriteDoneBrowserComponent